import { gql } from "@apollo/client";
import { QUERY_FOR_DASHBOARD } from "./query/dashboard";
import {
  QUERY_FEED_LIST,
  QUERY_MERCHANT_FEED,
  QUERY_PRODUCT_REVIEW_LIST,
  QUERY_SUPPLIER_REQUEST_LIST,
} from "./query/product";
import { MUTATION_DISCOUNT_CREAT, MUTATION_DISCOUNT_UPDATE, QUERY_DISCOUNT, QUERY_DISCOUNT_ITEM } from "./discount";

const QUERY_MERCHANT = gql`
  query merchant {
    merchant {
      id
      name
      logo
      banner
      origin
      address
      contact
      emails
      registerNumber
      vat
      role
      fiscalCodeNumber
      bankAccountHoldName
      bankAccountNumber
      bankName
      ownerName
      ownerType
      ownerNumber
      coordLat
      coordLng
      approvedDate
      approvedBy
      balance
      frontStoreImage
      pos
      userType
      isMoreSecurity
      recruiterId
      abaLink
      enabledChat
      verifiedBankAccount
      telegramGroupId
      # prefix
      paidRegister
    }
    supplierSetting {
      minimumDeliverTime
      exchangeRate
      packageValueLimit
      packageReachLimitMessage
      enabledChat
      affiliateThirdPartyBank
    }
    supplierSettingList
  }
`;

const QUERY_SALE_ALL_TIME = gql`
  query merchantAllSale {
    merchantAllSale {
      title
      completed
      return
      amountReturn
      sold
      sale
      total
    }
  }
`;

// Mutation
const MUTATION_TOGGLE_PUBLISH_FEED = gql`
  mutation merchantTogglePublishFeed($feedId: Int!) {
    merchantTogglePublishFeed(feedId: $feedId)
  }
`;

export const Graphql = {
  Query: {
    QUERY_MERCHANT,
    QUERY_FOR_DASHBOARD,
    QUERY_SALE_ALL_TIME,
    QUERY_PRODUCT_REVIEW_LIST,
    QUERY_FEED_LIST,
    QUERY_MERCHANT_FEED,
    QUERY_SUPPLIER_REQUEST_LIST,
    QUERY_DISCOUNT,
    QUERY_DISCOUNT_ITEM,
  },
  Mutation: {
    MUTATION_TOGGLE_PUBLISH_FEED,
    MUTATION_DISCOUNT_CREAT,
    MUTATION_DISCOUNT_UPDATE,
  },
};
